import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Notification } from '@offerzen/pinata'
import CheckCircleIcon from '@offerzen/zenicon/CheckCircleIcon'

import SendTerms from '../../SendTerms'
import AcceptTermsForm from '../AcceptTermsForm'

import styles from './styles'

const SignTermsFooter = ({ hasSignedTerms = false, token, companyId, setHasSignedTerms }) => {
  const [showSuccessNotice, setShowSuccessNotice] = useState()

  if (hasSignedTerms) return null

  return (
    <section className={styles.wrapper}>
      <hr />

      <Choose>
        <When condition={showSuccessNotice}>
          <Notification theme="success" icon={CheckCircleIcon}>
            <p role="status" className={styles.successNotification}>You’ve successfully accepted our terms.</p>
          </Notification>
        </When>

        <Otherwise>
          <h2 className={styles.title}>Accept OfferZen’s Terms</h2>

          <AcceptTermsForm
            token={token}
            companyId={companyId}
            onSubmitSuccess={() => {
              setShowSuccessNotice(true)
              setHasSignedTerms(true)
            }}
            className={styles.acceptTermsForm}
          />

          <SendTerms token={token} companyId={companyId} />
        </Otherwise>
      </Choose>
    </section>
  )
}

SignTermsFooter.propTypes = {
  hasSignedTerms: PropTypes.bool.isRequired,
  token: PropTypes.string,
  companyId: PropTypes.string.isRequired,
  setHasSignedTerms: PropTypes.func.isRequired,
}

export default SignTermsFooter
